import { call, put, select } from 'redux-saga/effects';
import { confirmCQ as confirmCQAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* confirmCQ(params) {
  const {
    reduxUpdate,
    cqId,
    documents,
    normalizeHttpErrors,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(confirmCQAda, { cqId, documents }, context);
    yield put(successUpdate(response));
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.CONFIRM_CQ, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
